import { Box, Typography, Button } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { useLanguage } from '../../../../context/language/language';
import { TitleModal } from '../../../MyAccount/common';
import { choiceSelectionModalSize } from '../modalSize';
import { getImageURL } from '../../../../utils/getImageURL';
import { ModalInfo } from '../../../common';
import useDeliveryControlFlow from '../../../common/hook/useDeliveryControlFlow';

const Icon = getImageURL('/icon/clear-cart.svg');

const CustomTitleModal = styled(TitleModal)(({ theme }) => ({
  ...theme.fonts.header3,
}));

const BtnCancel = styled(Button)(({ theme }) => ({
  width: '100%',
  marginRight: 8,
  backgroundColor: theme.colors.grey75,
  height: 44,
  textTransform: 'none',
  ...theme.radius.m,
  ...theme.fonts.header6,
}));

const BtnSubmit = styled(Button)(({ theme, disabled }) => ({
  width: '100%',
  backgroundColor: theme.colors.green600,
  color: disabled ? theme.colors.grey500 : theme.colors.white,
  height: 44,
  textTransform: 'none',
  ...theme.radius.m,
  ...theme.fonts.header6,

  '&:hover': {
    backgroundColor: theme.colors.green400,
  },
}));

const useStyle = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('md')]: {
      width: choiceSelectionModalSize.width,
      padding: 24,
      boxSizing: 'border-box',
    },
  }
}));

function ChangeCartStoreDialog(props) {
  const word = useLanguage();
  const classes = useStyle();
  const deliveryControl = useDeliveryControlFlow();
  
  return (
    <ModalInfo
      isOpen={deliveryControl.showModal}
      title={word('Alert.ClearCart.Title')}
      description={word('Alert.ClearCart.Description')}
      type="info"
      showCancel
      showIcon
      cancelText={word('General.Cancel')}
      labelText={word('General.New.Cart')}
      onClose={props.onClose}
      onConfirm={props.onNext}
    />
  );
}

export default ChangeCartStoreDialog;
